import Utils from "../../services/Utils.js";
import { _t } from "../../services/TranslationService.js";
import { getGameTemplate } from "../templates/game.js";
import { getFeaturedSportMatches } from "../../js/api/featuredPreMatch.js";
import { getSearchGames } from "../../js/api/search.js";
import { getSearchingGames } from "../templates/search-games.js";
import { isSportBlocked } from "../../services/BlockedSports.js";

let blockedSportRedirect = false;

let Sports = {
  render: async () => {
    blockedSportRedirect = false;
    let request = Utils.parseRequestURL();

    if (isSportBlocked(request.id)) {
      blockedSportRedirect = true;
      window.location.hash = "#/";
      return "";
    }

    let featuredPrematchs =
      (await getFeaturedSportMatches(request.id)) || [];

    const uniqueDates = [
      ...new Set(featuredPrematchs.map((item) => item.game_date)),
    ].sort();

    localStorage.setItem("matchSport", request.id);

    let gamesView = uniqueDates
      .map((date) => {
        let singleDateView = featuredPrematchs
          .filter((game) => game.game_date === date)
          .map((game) => (game.odd ? getGameTemplate(game, request.id) : ""))
          .join("");
        const dateStr = date;
        const formattedDate = dateStr.replace(
          /(\d{4})-(\d{2})-(\d{2})/,
          "$3/$2/$1"
        );
        return `
                <div class="flex flex-wrap flex-row w-full">
                    <div class="flex w-full text-[11px] px-1 text-[#ffff00] bg-black/40">
                        <span>${formattedDate}</span>
                    </div>
                    <div class="titleTobeHidden flex w-full text-[11px] leading-[20px] h-[20px] px-1 text-[#ffff00] border-l-[2px] border-[#008000]">
                        <span class="pl-1">Rezultat Final</span>
                    </div>
                    <div class="flex flex-row flex-wrap w-full">
                        ${singleDateView}
                    </div>
                </div>
            `;
      })
      .join("");

    if (!gamesView) {
      gamesView = `<h3>${_t("Ska loje")}</h3>`;
    }

    let view = /*html*/ `
            <div class="bg-[rgba(0,0,0,0.2)] w-full flex flex-wrap flex-col">
                <h2 class="flex flex-wrap flex-row text-center justify-center w-full bg-[#232323] text-white text-[11px] leading-[17px] font-bold text-center px-0 pt-[4px] pb-[7px] overflow-hidden text-ellipsis bg-gradient-to-t from-[#232323] to-[#494949]">
                    Te Gjitha
                </h2>
                <div class="flex items-center justify-between p-1 pb-0">
                    <div class="flex topHolder">
                        <div class="searchHolder w-full relative">
                            <div class="searchHeader relative">
                                <div class="relative w-full flex flex-wrap flex-row w-full">
                                    <img class="w-[14px] h-[14px] absolute left-1 top-[50%] -translate-y-1/2 pointer-none" src="~/../img/search.png" />
                                    <input type="text" id="findGame" class="searchInputLabel1 bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.4)] text-white h-[20px] text-[12px] pl-5" />

                                    <div class="helper1 absolute right-0 top-0 cursor-pointer w-[40px] h-[20px] z-10 hidden flex-wrap flex-row spasce-x-2 justify-between">
                                        <div class="closeSearch flex items-center w-[20px] h-[20px]">
                                            <span class="text-white text-[14px] w-[20px] leading-[20px] text-center font-bold">x</span>
                                        </div>
                                        <div class="closeSearch w-[20px] h-[20px]">
                                            <svg class="w-full h-full fill-white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="icon" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                                                <path d="M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8  l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"/>
                                                <rect id="_x3C_Transparent_Rectangle_x3E__589_" class="st0" width="32" height="32"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="searchContent1 absolute w-auto left-0 top-[25px] bg-white z-10 h-auto max-h-[calc(100vh-178px)] overflow-y-scroll ease-in-out duration-100" id="searchContent1"></div>
                        </div>
                    </div>
                    <div class="flex items-center text-sm">
                        <span class="text-white text-[11px] mr-1">Rendit Sipas:</span>
                        <select class="w-[100px] leading-[10px] h-[17px] text-white text-[11px] bg-[#808080] bg-[url('./img/select-arrow.png')] bg-no-repeat bg-[90%_center] border-0 appearance-none text-indent-[0.01px] overflow-hidden rounded-none">
                            <option>Orës</option>
                        </select>
                    </div>
                </div>
                <div id="gamesLeagueWrapper">${gamesView}</div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    if (blockedSportRedirect) return;

    let request = Utils.parseRequestURL();

    window.addEventListener("hashchange", async () => {
      localStorage.setItem("matchSport", request.id);
    });

    $(document)
      .off("click.topHolder.searchclose", ".closeSearch")
      .on("click.topHolder.searchclose", ".closeSearch", function () {
        $("body .searchInputLabel1").val("");
        $("body .searchInputLabel1").blur();
        $("body #searchContent1").html("");
        $("body .helper1").removeClass("flex");
        $("body .helper1").addClass("hidden");
      });

    let searchTimeout;
    const findGameInput = document.getElementById("findGame");

    findGameInput.addEventListener("keyup", () => {
      clearTimeout(searchTimeout); // Clear previous timeout to debounce

      const bettingButtons = document.querySelectorAll(".bettingBtn");

      searchTimeout = setTimeout(async () => {
        const $input = $("body .searchInputLabel1").val();

        const $content = $("body #searchContent1");
        const $helper = $("body .helper1");

        // Reset when empty
        if ($input.length === 0) {
          $input.val("").focus();
          $helper.removeClass("flex").addClass("hidden");
          return;
        }

        // Only search when 3+ chars
        if ($input.length < 2) return;

        try {
          const searchValues = await getSearchGames($input);

          if (!Array.isArray(searchValues) || searchValues.length === 0) {
            // No results
            $content.html(``);
            $helper.removeClass("flex").addClass("hidden");
            return;
          }

          // Get unique, sorted YYYY-MM-DD dates (lexicographic works for ISO)
          const uniqueDates = [
            ...new Set(searchValues.map((i) => i.game_date)),
          ].sort();

          let searchGamesView = "";

          uniqueDates.forEach((date) => {
            let singleDateView = "";

            const currentUrlIsLive = window.location.hash; // Get current hash URL
            const base = searchValues
              // skip invalid/excluded
              .filter((a) => a?.odd && a.id !== 372481 && a?.type_id != null); // require type_id

            base
              .filter((a) => Number(a.type_id) === 1)
              .forEach((a) => {
                if (a.game_date !== date) return;
                singleDateView += getSearchingGames(a, "1");
              });

            if (singleDateView) {
              searchGamesView += `
              <div class="searchLabelGroup flex flex-wrap flex-row w-full">
                <div class="search-games w-full space-y-2">
                  <ul>${singleDateView}</ul>
                </div>
              </div>
            `;
            }
          });

          // If all items were filtered out, show "no results"
          if (!searchGamesView) {
            $content.html(`
                        <div class="p-3 text-sm text-white/80 bg-black/40">
                        No matches for "<span class="font-semibold">${term}</span>".
                        </div>
                    `);
          } else {
            $content.html(searchGamesView);
          }

          // Open panel
          $helper.removeClass("hidden").addClass("flex");
        } catch (err) {
          console.error("Search error:", err);
          $content.html(`
                  <div class="p-3 text-sm text-red-300 bg-black/40">
                    Something went wrong while searching. Please try again.
                  </div>
                `);
          $helper.removeClass("hidden").addClass("flex");
        }
      }, 300); // Delay of 300ms
    });
  },
};

export default Sports;
